export default [
    // {
    //     path: '/setting/voip',
    //     name: 'Settings_Voip',
    //     component: () => import('@/views/setting/voip/form.vue'),
    //     meta: {
    //         authRequired: true,
    //         permission: 'Settings_Voip'
    //     }
    // },
    {
        path: '/setting/sms',
        name: 'Settings_Sms',
        component: () => import('@/views/setting/sms/form.vue'),
        meta: {
            authRequired: true,
            permission: 'settings.sms'
        }
    },
    // {
    //     path: '/setting/factor',
    //     name: 'Settings_Factor',
    //     component: () => import('@/views/setting/factor/form.vue'),
    //     meta: {
    //         authRequired: true,
    //         permission: 'Settings_Factor'
    //     }
    // },
    // {
    //     path: '/setting/sale',
    //     name: 'Settings_Sale',
    //     component: () => import('@/views/setting/sale/form.vue'),
    //     meta: {
    //         authRequired: true,
    //         permission: 'Settings_Sale'
    //     }
    // },
]